import { ReactElement } from 'react'
import 'react-quill/dist/quill.snow.css'
import 'react-quill/dist/quill.core.css'

/**
 * @param htmlVal value you want to dangerously set innerhtml
 * @param isEncoded bool if you have encoded it or not via encodeURI
 * Sets free text from  WYSISYG or some other editor to the dom
 * Probably need to eventually do this in a safer way
 */

export default ({
  htmlVal,
  isEncoded = false,
}: {
  htmlVal: string
  isEncoded?: boolean
}): ReactElement => (
  <div id="#quill" className="ql-editor">
    {htmlVal && (
      <div
        dangerouslySetInnerHTML={{
          __html: isEncoded ? decodeURI(htmlVal) : htmlVal,
        }}
      />
    )}
  </div>
)
